import ClearReset from "../components/ClearReset";
import * as actions from "../../common/actions";
import { StoreState } from "../../common/types/index";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import {
  initialCBSState,
  initialCBFState,
  initialSISState,
  initialSIFState,
  initialStateCleared,
  defaultSelectedStatesValue,
} from "../../refdata/FilterOptions";

export function mapStateToProps({ query }: StoreState.All) {

  return {
    selectedReport: query.filters.selectedReport,
    selectedStartDate: query.filters.selectedStartDate,
    selectedEndDate: query.filters.selectedEndDate,
    selectedStates: query.filters.selectedStates,
    previousLocations: query.filters.previousLocations,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    onClear: (
      selectedReport: string,
      selectedStartDate: string,
      selectedEndDate: string,
      selectedStates: string[],
      previousLocations: string[],
    ) => {

      //keeps current selections for start/end date, and selected locations
      initialStateCleared.filters.selectedStartDate = selectedStartDate;
      initialStateCleared.filters.selectedEndDate = selectedEndDate;
      initialStateCleared.filters.selectedStates = selectedStates;
      initialStateCleared.filters.previousLocations = previousLocations;

      dispatch(actions.resetState (initialStateCleared));
      dispatch(actions.updateFilter("selectedReport", selectedReport));
    },
    onReset: (
      selectedReport: string,
      selectedStartDate: string,
      selectedEndDate: string,
    ) => {
      const reportDispatchActions: { [key: string]: any } = {
        "CBS": initialCBSState,
        "CBF": initialCBFState,
        "SIS": initialSISState,
        "SIF": initialSIFState,
      };

      //keeps current selections for start and end date
      reportDispatchActions[selectedReport].filters.selectedStartDate = selectedStartDate;
      reportDispatchActions[selectedReport].filters.selectedEndDate = selectedEndDate;
      //resets selected states to default
      reportDispatchActions[selectedReport].filters.selectedStates = defaultSelectedStatesValue;
      reportDispatchActions[selectedReport].filters.previousLocations = defaultSelectedStatesValue;
      
      dispatch(actions.resetState(reportDispatchActions[selectedReport]));
      dispatch(actions.updateFilter("selectedReport", selectedReport));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ClearReset);
